/* ==========================================================================
   BSC Academy — filtri del catalogo · v1 · 25/08/2026

   I prodotti sono già tutti nel DOM: qui si nascondono e si mostrano.
   Senza questo file la pagina resta completa e navigabile. → playbook §9.3

   Init per-istanza: la stessa sezione può stare due volte in pagina.
   Smontaggio su shopify:section:unload. → Errori §0.1.3 e §0.1.4
   ========================================================================== */

(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.bscCatInit) { return; }

    var griglia = root.querySelector('[data-bsc-griglia]');
    var barra = root.querySelector('[data-bsc-filtri]');
    if (!griglia || !barra) { return; }   // guard: niente markup, niente init

    root.dataset.bscCatInit = '1';

    var card = Array.prototype.slice.call(griglia.querySelectorAll('.bsc-perc'));
    var chip = Array.prototype.slice.call(barra.querySelectorAll('.bsc-chip'));
    var vuoto = root.querySelector('[data-bsc-vuoto]');
    var altri = root.querySelector('[data-bsc-altri]');

    var passo = parseInt(griglia.dataset.passo, 10) || 4;
    var mostrati = passo;
    var stato = { cat: '', fmt: '' };

    function combacia(el) {
      var okCat = !stato.cat || (' ' + el.dataset.cat + ' ').indexOf(' ' + stato.cat + ' ') !== -1;
      var okFmt = !stato.fmt || (' ' + el.dataset.fmt + ' ').indexOf(' ' + stato.fmt + ' ') !== -1;
      return okCat && okFmt;
    }

    var primaVolta = true;

    /* ── la transizione fra i filtri ────────────────────────────────────────
       Flip fa scivolare le card che restano e gestisce chi entra e chi esce.
       Con `absolute: true` le toglie dal flusso, quindi la griglia va tenuta
       in piedi a mano.

       ⚠️ LA COSA CHE MI E COSTATA TRE GIRI: non basta bloccare l'altezza,
       bisogna liberarla NEL MOMENTO GIUSTO. La tween dell'altezza dura 0,5s,
       ma Flip dura molto di piu: ai suoi 0,5s si sommano lo stagger su tutte
       le card e le sotto-animazioni di chi entra. Liberando l'altezza a 0,5s
       la griglia collassava mentre le card erano ancora assolute — la pagina
       saliva e poi tornava giu.
       Ora tutto sta in UNA timeline: si libera solo quando l'ultima card e
       atterrata. (Rami, 25/08)
       ──────────────────────────────────────────────────────────────────── */
    function muta(fn) {
      if (!window.gsap || !window.Flip || primaVolta) { fn(); return; }

      var DUR = 0.5;

      function misura(el) { return el ? el.getBoundingClientRect().height : 0; }

      /* Il contenitore del pulsante NON si tocca: il suo spazio e riservato
         sempre dal CSS, cosi l'altezza della sezione e identica che il
         pulsante ci sia o no. E l'unica cosa che cambiava fra un filtro e
         l'altro, visto che con quattro card o meno la griglia resta una riga
         sola. (Rami, 25/08) */

      // 1. blocca la griglia, prima di ogni altra cosa
      griglia.style.height = misura(griglia) + 'px';

      // 2. cattura
      var stato = Flip.getState(card, { props: 'opacity' });

      // 3. muta (card + pulsante + messaggio di vuoto, tutto insieme)
      fn();

      // 4. misura le altezze VERE: liberando e ri-bloccando nello stesso ciclo
      //    (`scrollHeight` e le misure a box bloccato mentono)
      var gH = griglia.style.height;
      griglia.style.height = '';
      var gDopo = misura(griglia);
      griglia.style.height = gH;

      // 5. una sola timeline: Flip e le altezze insieme
      var tl = gsap.timeline({
        onComplete: function () {
          griglia.style.height = '';
          gsap.set(card, { clearProps: 'opacity,transform' });
          if (window.ScrollTrigger) { ScrollTrigger.refresh(); }
        }
      });

      tl.add(Flip.from(stato, {
        duration: DUR,
        ease: 'power2.inOut',
        absolute: true,
        stagger: 0.02,
        onEnter: function (els) {
          return gsap.fromTo(els,
            { opacity: 0, scale: 0.94, y: 16 },
            { opacity: 1, scale: 1, y: 0, duration: 0.45, ease: 'power3.out', stagger: 0.035 });
        },
        onLeave: function (els) {
          return gsap.to(els, { opacity: 0, scale: 0.96, duration: 0.26, ease: 'power2.in' });
        }
      }), 0);

      tl.to(griglia, { height: gDopo, duration: DUR, ease: 'power2.inOut' }, 0);
    }

    function applica() {
      var trovate = 0, viste = 0;

      for (var i = 0; i < card.length; i++) {
        if (combacia(card[i])) {
          trovate++;
          if (viste < mostrati) { viste++; }
        }
      }

      /* card, pulsante e messaggio di vuoto cambiano DENTRO la mutazione:
         se il pulsante comparisse dopo, sarebbe un secondo salto */
      muta(function () {
        var n = 0;
        for (var j = 0; j < card.length; j++) {
          var ok = combacia(card[j]) && n < mostrati;
          card[j].hidden = !ok;
          if (ok) { n++; }
        }

        if (vuoto) { vuoto.hidden = trovate !== 0; }

        if (altri) {
          var restano = trovate - viste;
          altri.hidden = restano <= 0;
          if (restano > 0) {
            /* i testi arrivano dal Liquid: il pannello del tema li puo
               cambiare senza che nessuno apra questo file */
            altri.textContent = altri.dataset.testo || 'Mostra di più';
            altri.setAttribute('aria-label', (altri.dataset.aria || 'Mostra altri percorsi') + ' (' + restano + ')');
          }
        }
      });

      if (!window.gsap && window.ScrollTrigger) { ScrollTrigger.refresh(); }
    }

    function premuto(b) {
      var gruppo = b.dataset.f;
      for (var i = 0; i < chip.length; i++) {
        if (chip[i].dataset.f === gruppo) {
          chip[i].setAttribute('aria-pressed', String(chip[i] === b));
        }
      }
      stato[gruppo] = b.dataset.v;
      mostrati = passo;   /* cambiando filtro si riparte dalla prima riga */
      applica();
    }

    /* ---- interruttore: le aree in piu ------------------------------------ */
    var piu = root.querySelector('[data-bsc-piu]');
    var extra = root.querySelector('[data-bsc-extra]');
    if (piu && extra) {
      piu.addEventListener('click', function () {
        var aperto = piu.getAttribute('aria-expanded') === 'true';
        piu.setAttribute('aria-expanded', String(!aperto));
        piu.setAttribute('aria-label', aperto ? 'Mostra tutte le aree' : 'Nascondi le altre aree');
        if (aperto) { extra.removeAttribute('data-aperto'); }
        else { extra.setAttribute('data-aperto', ''); }
      });
    }

    /* ---- interruttore: i formati ----------------------------------------- */
    var icoFmt = root.querySelector('[data-bsc-fmt-toggle]');
    var boxFmt = root.querySelector('[data-bsc-formati]');
    if (icoFmt && boxFmt) {
      icoFmt.addEventListener('click', function () {
        var aperto = icoFmt.getAttribute('aria-expanded') === 'true';
        icoFmt.setAttribute('aria-expanded', String(!aperto));
        if (aperto) { boxFmt.removeAttribute('data-aperto'); }
        else { boxFmt.setAttribute('data-aperto', ''); }
      });
    }

    /* se un formato e gia filtrato, il pannello resta aperto */
    for (var f = 0; f < chip.length; f++) {
      if (chip[f].dataset.f === 'fmt' && chip[f].dataset.v && chip[f].getAttribute('aria-pressed') === 'true') {
        if (icoFmt && boxFmt) { icoFmt.setAttribute('aria-expanded', 'true'); boxFmt.setAttribute('data-aperto', ''); }
      }
    }

    for (var c = 0; c < chip.length; c++) {
      (function (b) {
        b.addEventListener('click', function () { premuto(b); });
      })(chip[c]);
    }

    if (altri) {
      altri.addEventListener('click', function () {
        mostrati += passo;
        applica();
        /* il focus va alla prima card appena comparsa: da tastiera,
           altrimenti si resta sul pulsante e non si capisce cosa e successo */
        for (var i = 0; i < card.length; i++) {
          if (!card[i].hidden && !card[i].dataset.bscVista) {
            card[i].dataset.bscVista = '1';
            var link = card[i].querySelector('a');
            if (link) { link.focus({ preventScroll: true }); }
            break;
          }
        }
      });
    }

    applica();
    primaVolta = false;
  }

  function smonta(scope) {
    if (!scope) { return; }
    var r = scope.querySelector('.bsc-cat') || scope;
    if (r && r.dataset) { delete r.dataset.bscCatInit; }
  }

  function tutte(scope) {
    var nodi = (scope || document).querySelectorAll('.bsc-cat');
    for (var i = 0; i < nodi.length; i++) { init(nodi[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tutte(document); });
  } else {
    tutte(document);
  }

  document.addEventListener('shopify:section:load', function (e) { tutte(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { smonta(e.target); });
})();

/* ==========================================================================
   IL PANNELLO DEI FILTRI — solo telefono · 26/08/2026
   Sotto i 720px la barra dei filtri sta dietro un pulsante. Il markup e lo
   stesso: cambia solo dove viene disegnato. Qui si gestiscono apertura,
   chiusura e il numero di filtri accesi sul pulsante.
   ========================================================================== */
(function () {
  'use strict';

  var apri = document.querySelector('[data-bsc-apri-filtri]');
  var pannello = document.querySelector('[data-bsc-filtri]');
  var chiudi = document.querySelector('[data-bsc-chiudi-filtri]');
  var conta = document.querySelector('[data-bsc-conta-filtri]');
  if (!apri || !pannello) { return; }

  /* Il pannello e un <dialog>: `showModal()` lo porta nel top layer, sopra
     qualunque z-index e fuori da qualunque antenato trasformato. Esc, focus
     trattenuto e sfondo oscurato arrivano col metodo, senza scriverli. */
  function mostra(si) {
    if (si) {
      if (typeof pannello.showModal === 'function') { pannello.showModal(); }
      else { pannello.setAttribute('open', ''); }
      /* ⚠️ Il fuoco va sul pannello, non sul primo pulsante che lo puo
         prendere. `showModal()` da solo lo mette sulla crocetta, e Chrome le
         disegna intorno l'anello del fuoco da tastiera: uno apre i filtri e
         trova un pulsante che sembra gia selezionato. Il `autofocus` sul
         <dialog> non basta — il browser continua a cercare un discendente.
         Col fuoco sul pannello (che ha tabindex="-1") non c'e anello, e chi
         naviga da tastiera resta comunque dentro. (Rami, 27/08) */
      pannello.focus();
    } else if (pannello.open) {
      pannello.close();
    }
    apri.setAttribute('aria-expanded', si ? 'true' : 'false');
  }

  /* Quanti filtri sono accesi. «Tutte» non conta: e lo stato di partenza,
     non una scelta. */
  function aggiornaConteggio() {
    if (!conta) { return; }
    var accesi = document.querySelectorAll('.bsc-chip[aria-pressed="true"][data-v]:not([data-v=""])').length;
    conta.textContent = accesi;
    conta.hidden = accesi === 0;
  }

  apri.addEventListener('click', function () { mostra(!pannello.open); });
  if (chiudi) { chiudi.addEventListener('click', function () { mostra(false); }); }
  /* Esc lo gestisce il <dialog> da solo: qui si rimette solo il fuoco dove
     stava, che il browser non fa. */
  pannello.addEventListener('close', function () {
    apri.setAttribute('aria-expanded', 'false');
    apri.focus();
  });
  /* un clic sullo sfondo scuro chiude, come ci si aspetta da una modale */
  pannello.addEventListener('click', function (ev) {
    if (ev.target === pannello) { mostra(false); }
  });
  /* ogni scelta aggiorna il numero; il pannello resta aperto, cosi se ne
     possono fare piu di una senza riaprirlo ogni volta */
  pannello.addEventListener('click', function (ev) {
    if (ev.target.closest('.bsc-chip')) { setTimeout(aggiornaConteggio, 0); }
  });
  addEventListener('resize', function () {
    if (innerWidth > 720 && pannello.open) { mostra(false); }
  }, { passive: true });

  aggiornaConteggio();
})();
